import { useSelector } from 'react-redux';
import DashboardHomePage from './DashboardHomePage';
import { getUserFullName } from 'app/utils/appHelpers';
import { Typography } from '@mui/material';


const Home = () => {

    const { authUser } = useSelector(state => state.auth);

    return (
        <div>

            <div>


                {authUser !== null && (() => {

                    return <DashboardHomePage />;



                    return null; // Hiçbir role uymuyorsa null döndür
                })()}



            </div>

            {/* <p> {process.env.NODE_ENV} {process.env.REACT_APP_API_URL}</p> */}
        </div>
    );
};
export default Home;